import { canEnableSwiperLoop } from './utils';

export default () => ({
    swiper: null,
    init() {
        this.enable();
    },
    enable() {
        const breakpoints = {
            320: {
                slidesPerView: 1.5,
                navigation: false,
            },
            568: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 4,
            },
        };

        this.swiper = new Swiper(this.$refs.productRecommendations, {
            slidesPerView: 3,
            spaceBetween: 8,
            pagination: false,
            loop: canEnableSwiperLoop(this.$refs.productRecommendations, { slidesPerView: 3, breakpoints }),
            navigation: {
                nextEl: this.$refs.next,
                prevEl: this.$refs.previous,
            },
            breakpoints,
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            keyboard: {
                enabled: true,
            },
        });
    },
});
